<template>
  <div>
    <div>
      <!--блок с фото-->
      <div class="uk-position-relative uk-text-center"
           @mousemove="photoAfterVisible = false; beforeVisible = true; description = false;"
           @mouseleave="photoAfterVisible = true; beforeVisible = false"
           @click="mainPhotoClick('main_photo_before_zoomed', 'main_photo_after_zoomed')">
        <!--фото BEFORE-->
        <template v-if="(photoAfterVisible || beforeVisible) && !(withFacesVisible) && !(zoneVisible && !beforeVisible && !withFacesVisible)">
          <!--прилодер между фото для зума-->
          <preloader :is-visible="zoomLoading" style="position: absolute"></preloader>
          <template v-if="main_photo_before">
            <div class="uk-inline-clip tm-block-img 31" v-show="(beforeVisible || main_photo_after == null) && !isRedo">
              <inner-image-zoom
                  :src="main_photo_before"
                  :zoomSrc="main_photo_before_zoomed_computed"
                  :zoomPreload="true"
                  :className="'main_photo_before_zoomed'"
                  :afterZoomIn="afterZoomInMethod('main_photo_before_zoomed', 'main_photo_after_zoomed')"
                  :afterZoomOut="afterZoomOutMethod('main_photo_before_zoomed', 'main_photo_after_zoomed')"
                  moveType="drag"/>
            </div>
            <div class="uk-inline-clip tm-block-img 33" v-show="(beforeVisible || main_photo_after == null) && isRedo">
              <img class="main-photo" :src="main_photo_before" alt="фото Зона" style="min-height: 100%;">
            </div>
          </template>
<!--          <div v-else class="uk-inline-clip tm-block-img 31">-->
<!--            <img src="/img/images.png" class="main-photo" alt="/img/after.jpg">-->
<!--          </div>-->
          <!--фото AFTER-->
          <template v-if="main_photo_after">
            <div class="uk-inline-clip tm-block-img 32" v-show="photoAfterVisible">
              <inner-image-zoom
                  :src="main_photo_after"
                  :zoomSrc="main_photo_after_zoomed_computed"
                  :zoomPreload="true"
                  :className="'main_photo_after_zoomed'"
                  :afterZoomIn="afterZoomInMethod('main_photo_after_zoomed', 'main_photo_before_zoomed')"
                  :afterZoomOut="afterZoomOutMethod('main_photo_after_zoomed', 'main_photo_before_zoomed')"
                  moveType="drag"/>
            </div>
          </template>
<!--          <div v-else class="uk-inline-clip tm-block-img 32">-->
<!--            <img src="/img/images.png" class="main-photo" alt="/img/after.jpg">-->
<!--          </div>-->
        </template>
        <!--фото зоны от клиента-->
        <div v-if="withFacesVisible" class="uk-inline-clip uk-transition-toggle tm-block-img 4">
          {{ setDescription('main_photo_before_with_faces', main_photo_before_with_faces) }}
          <img v-if="main_photo_before_with_faces !== null" class="main-photo" :src="main_photo_before_with_faces" alt="фото Зона" style="min-height: 100%;">
          <img v-else class="main-photo" src="/img/images.png" alt="фото Зона">
        </div>
        <div v-if="false && withFacesVisible && (appVersion.indexOf('1.11.12') > -1 || appVersion.indexOf('1.11.11 (168)') > -1)" class="uk-inline-clip uk-transition-toggle tm-block-img 4">
          <div :style="order_photo_before_url_style"></div>
          {{ setDescription('main_photo_before_with_faces', main_photo_before_with_faces) }}
          <img v-if="main_photo_before !== null" class="main-photo" :src="main_photo_before" alt="">
          <img v-else src="/img/images.png" class="main-photo" alt="">
        </div>
        <!--фото примеры функций, скачать-->
        <div v-if="zoneVisible && !beforeVisible && !withFacesVisible" class="uk-inline-clip uk-transition-toggle tm-block-img 5">
         {{ setDescription('zone_photo', zone_photo) }}
          <img v-if="zone_photo !== null" class="main-photo" :src="zone_photo" alt="фото пример функции" style="min-height: 100%;">
          <img v-else class="main-photo" src="/img/images.png" alt="фото пример функции">
        </div>
      </div>
      <!--блок подписи фото + кнопка скачать before-->
      <div class="uk-grid uk-grid-small uk-flex-middle uk-margin-xsmall-top uk-animation-slide-small-medium 3" data-uk-grid>
        <!--блок подписи фото-->
        <div>
          <div class="tm-left-photo-hover-description">
            <span v-if="isLoading" class="uk-icon uk-spinner uk-margin-small-left uk-light" data-uk-spinner="ratio: 0.7"></span>
            <div class="uk-text-truncate" v-else>
              <template v-if="description && !afterVisible">
                {{ description }}
              </template>
              <template v-else-if="descriptionComputed">
                {{descriptionComputed}}
              </template>
              <template v-else>
                no data
              </template>
            </div>
          </div>
        </div>
        <!--ZOOM переключатель-->
        <div>
          <ul class="uk-subnav uk-subnav-pill uk-flex-center tm-subnav-small">
            <template v-for="level in zoomLevels">
              <li :class="level == zoomLevel ? 'uk-active': ''" :key="level">
                <a @click="setZoomLevel(level)">{{ level + 'x' }}</a>
              </li>
            </template>
          </ul>
        </div>
        <div class="uk-width-expand"></div>
        <!--сравнение версий-->
        <template>
          <div class="tm-compare tm-compare-for-pro" style="font-weight: 100" data-ver-compare="for_pro">
            <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
              <template v-if="fullImageList.length > 0 && Object.keys(this.main_photo_block).includes('main_photo_after')">
                <div>
                  <!--при наведении-->
                  <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                    <div>
                      <button @click="photoDownload(selectedOptionSource)" class="uk-button uk-button-success tm-button-compare" :data-uk-tooltip="local_page_keys.button_download + ' - ' + description ">
                        <md-icon>file_download</md-icon>
                      </button>
                    </div>
                    <div>
                      <select class="uk-select tm-select-compare" v-model="selectedOptionSource">
                        <option v-for="(item, index) in fullImageList" :key="index" :value="item.value">{{ item.name }}</option>
                      </select>
                      <div class="uk-dropdown tm-dropdown tm-dropdown-top-center" data-uk-dropdown="pos: top-center; offset: 15">
                        {{local_page_keys.description_label_source}}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <md-icon class="">compare_arrows</md-icon>
                </div>
              </template>
              <template v-if="fullImageList.length > 0 && Object.keys(this.main_photo_block).includes('main_photo_before')">
                <div>
                  <!--видимое фото-->
                  <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                    <div>
                      <select class="uk-select tm-select-compare" v-model="selectedOptionHover">
                        <option v-for="(item, index) in fullImageList" :key="index" :value="item.value">{{ item.name }}</option>
                      </select>
                      <div class="uk-dropdown tm-dropdown tm-dropdown-top-center" data-uk-dropdown="pos: top-center; offset: 15">
                        {{local_page_keys.description_label_on_hover}}
                      </div>
                    </div>
                    <div>
                      <button @click="photoDownload(selectedOptionHover)" class="uk-button uk-button-success tm-button-compare" :data-uk-tooltip="local_page_keys.button_download + ' - ' + tooltipPhotoDownloadHover ">
                        <md-icon>file_download</md-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--диалоговое окно ДО/ПОСЛЕ при клике на фото-->
    <md-dialog
        class="tm-gal-dialog"
        :md-active.sync="showDialog8"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog8 = false"><span
            class="material-icons">close</span></a>
        <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
          <comparify
              v-if="main_modal_photo_before !== '/img/images.png' && main_modal_photo_after !== '/img/images.png'"
              :before="main_modal_photo_before" :after="main_modal_photo_after">
            <i class="fa fa-angle-left" aria-hidden="true" slot="icon-left"></i>
            <i class="fa fa-angle-right" aria-hidden="true" slot="icon-right"></i>
          </comparify>
          <img class="alter-photo"
               v-else-if="main_modal_photo_before !== '/img/images.png' && main_modal_photo_after === '/img/images.png'"
               :src="main_modal_photo_before" alt="">
          <img class="alter-photo"
               v-else-if="main_modal_photo_before === '/img/images.png' && main_modal_photo_after !== '/img/images.png'"
               :src="main_modal_photo_after" alt="">
          <img class="alter-photo" v-else src="/img/images.png" alt="">
        </div>

      </div>
    </md-dialog>
  </div>
</template>

<script>
import Comparify from "@/pages/Dashboard/Components/Comparify";
import Preloader from "@/pages/Dashboard/Components/Preloader";
// import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'
//import VuePhotoZoomPro from 'vue-photo-zoom-pro'
import InnerImageZoom from 'vue-inner-image-zoom';

export default {
  name: "RetouchersMainPhotoBlock",
  props: {
    order_number: {
      type: String,
      require: true
    },
    main_photo_block: {
      type: Object,
      require: true
    },
    zone_photo: {
      require: true,
    },
    withFacesVisible: {
      type: Boolean,
      require: true
    },
    afterVisible: {
      type: Boolean,
      require: true
    },
    zoneVisible: {
      type: Boolean,
      require: true
    },
    fullImageList: {
      type: Array,
      require: true
    },
    isOutChat: {
      type: Boolean,
      require: true
    },
  },
  components: {
    Comparify,
    //VuePhotoZoomPro,
    Preloader,
    InnerImageZoom
  },
  data: () => ({
    actionBlockSelects: null,
    main_photo_after: null,
    main_photo_before: null,
    main_photo_before_with_faces: null,
    selected1: null,
    textarea1: null,
    file1: null,
    file: null,
    selectedVersion: null,
    select1: [],
    select_problem: {},
    photoAfterVisible: true,
    beforeVisible: false,
    main_modal_photo_before: '',
    main_modal_photo_after: '',
    showDialog8: false,
    local_page_keys: {},
    local_page_keys_functions: {},
    orderId: '',
    images_types: 'image/jpeg,image/png',
    zoomMode: true,
    zoomLevel: 3,
    zoomLevelOld: 2,
    zoomLevels: [2, 3, 4],
    zoomLoading: false,
    zoomImage: '',
    zoomHighImage: '',
    zoomImageType: 'before',
    zoomType: 'circle',
    description: '',
    functionsClientFile: null,
    main_photo_before_zoomed: '',
    main_photo_after_zoomed: '',
    observedZoomedElementStyle:'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
    observedZoomedElementStyleOld:'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
    // main_photo_before_zoomed_style: 'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
    // main_photo_after_zoomed_style: 'top: 0px; left: 0px; transition: opacity 150ms linear 0s, visibility 150ms linear 0s;',
    selectedOptionHover: null,
    selectedOptionSource: null,
    isRedo: false
  }),
  methods: {
    showMainPhoto() {
      this.showDialog8 = true;
      this.main_modal_photo_before = (this.main_photo_before ? this.main_photo_before : "/img/images.png");
      this.main_modal_photo_after = (this.main_photo_after ? this.main_photo_after : "/img/images.png");
    },
    setZoomLevel(level) {
      if (this.zoomLevels.includes(level)) {

        this.zoomLevelOld = this.zoomLevel;
        this.zoomLevel = level;
        if(this.zoomLevel != this.zoomLevelOld){
          this.zoomLoading = true;
          this.zoomImageRatioErase();
          this.readAndPreviewZoomImage('main_photo_before');
          this.readAndPreviewZoomImage('main_photo_after');
          this.changeZoomStyle();
        }
      }
    },
    setZoomImage(type) {
      if (type == 'before') {
        this.zoomImage = this.main_photo_before;
        this.zoomHighImage = this.main_photo_before;
        this.zoomImageType = 'before';
      }
      if (type == 'after') {
        this.zoomImage = this.main_photo_after;
        this.zoomHighImage = this.main_photo_after;
        this.zoomImageType = 'after';
      }
    },
    setDescription(type, file = null) {
      this.isRedo = false;
      switch (type) {
        case "main_photo_after":
          this.description = this.local_page_keys.description_photo_marking_after;
          break;
        case "main_photo_before":
          this.description = this.local_page_keys.description_photo_marking_before;
          break;
        case "main_photo_before_with_faces":
          this.description = this.local_page_keys.description_photo_marking_face_zone;
          break;
        case "zone_photo":
          this.description = this.parseFileName(file)
          break;
        default:
          this.description = '';
          break;
      }
    },
    parseFileName(url) {
      if (!url)
        return '';

       const foundItem = this.fullImageList.find(item => item.value === url);
       const file  = foundItem && foundItem.file_name ? foundItem.file_name : url;

      //https://retoucher.app:10001/storage/order_photos/1002825548/order_photo_before_url.jpg
      if (file.includes("order_photo_before_url")) {
        return this.local_page_keys.description_photo_marking_before;
      }
      if (file.includes("order_photo_")) {
        const regex = /order_photo_after_(\d+)/;
        const match = file.match(regex);
        const number = match ? match[1] : '';
        return this.local_page_keys.description_photo_marking_after + ' ' +  number;
      }
      //https://nvp2.retoucher.app:10001//storage/elements/tiny/order_eyebrow_piercing_12_tiny.jpg/
      if (file.includes("elements/tiny/")) {
        const regex = /order_(.*)\_tiny.jpg/i;
        const match = file.match(regex);
        if (match && match[1]) {
          const result = match[1].replace(/_/g, ' ');
          return result;
        }
      }
      //https://fix-dashboard.vagrant/api/storage/client_files/82925_1687436164.jpg
      if (file.includes("client_files/") && this.functionsClientFile) {
        const functionName = Object.keys(this.functionsClientFile).find(key => this.functionsClientFile[key] === file);

        if (this.local_page_keys_functions[functionName] !== undefined )
            return this.local_page_keys.client_photo_label + ' "' + this.local_page_keys_functions[functionName ] + '"';
        else
          return this.local_page_keys.client_photo_label;
      }
      //https://dl.dropbox.com/s/5nk7v46ejitrjjd/1687299957380971_redo.jpg
      if (file.includes("_redo")) {
        this.isRedo = true;
        return this.local_page_keys.description_photo_return;
      }
      //https://retoucher.app:10001/storage/order_photos/528544183/adminComments20230608145202_528544183.jpeg
      if (file.includes("adminComments")) {
        return this.local_page_keys.description_admin_comment;
      }
    },
    async fetchFunctionsClientFile() {
      await this.$store.dispatch('order/orderFunctionsClientFile', {order_id: this.orderId})
      let data = this.$store.getters['order/orderFunctionsClientFile'];
      this.functionsClientFile = typeof data !== 'string' ? data : null;
    },
    photoDownload(url) {
      let url_obj = new URL(url);

      //let path = url_obj.pathname;
      // let searchParams = new URLSearchParams(url);
      // let filename = searchParams.has('fn') ? searchParams.get('fn') : path.split('/').pop();

      let searchImage = this.fullImageList.find(image => image.value === url);
      let filename = searchImage ? searchImage.file_name : url;

      // if (url_obj.hostname === 'appfls.fixthephoto.com') { // проблема с CORS
      //   url_obj.hostname = 'fdl.retoucher.app';
      // }

      fetch(url_obj, {method: 'GET'})
          .then(response => response.blob())
          .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link); // we need to append the element to the dom -> otherwise it will not work in firefox
            link.click();
            link.remove();  //afterwards we remove the element again
            URL.revokeObjectURL(link.href)
          }).catch(e => alert(e))
    },
    async readAndPreviewZoomImage(main_photo_option){
      let largerImageData; // Declare a global variable
      let _this = this;
      function getFourTimesLargerImageDataFromURL(imageURL, scale = 2) {
        return new Promise((resolve, reject) => {
          //const scale = 2; // Scale factor to make the image four times larger

          const desiredHeight = 900;
          const img = new Image();
          img.crossOrigin = "Anonymous"; // Enable cross-origin requests if necessary
          img.onload = function() {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            // Calculate the new dimensions while maintaining the aspect ratio
            let newWidth = img.width * scale;
            let newHeight = img.height * scale;
            if(newHeight > desiredHeight * scale){
              newWidth = newWidth * (desiredHeight * scale / newHeight);
              newHeight = desiredHeight * scale;
              img.width = newWidth;
              img.height = newHeight;
            } else {
              newWidth = newWidth * (desiredHeight * scale / newHeight);
              newHeight = desiredHeight * scale;
              img.width = newWidth;
              img.height = desiredHeight * scale ;
            }
            if(!('zoom_' + scale in window)){
              window['zoom_' + scale] = {};
            }
            if(!('zoom_' + scale in window && 'imgHeight' in window['zoom_' + scale])) {
              window['zoom_' + scale].imgHeight = img.height;
              window['zoom_' + scale].imgWidth = img.width;
            }
            if('zoom_' + scale in window && 'imgHeight' in window['zoom_' + scale]){
              let scaleFactorHeight = window['zoom_' + scale].imgHeight / img.height;
              let scaleFactorWidth = window['zoom_' + scale].imgWidth / img.width;
              newHeight = img.height * scaleFactorHeight;
              newWidth = img.width * scaleFactorWidth;
            }
            canvas.width = newWidth;
            canvas.height = newHeight;

            // Draw the image on the canvas
            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            // Get the larger image data as a data URL

            largerImageData = canvas.toDataURL("image/jpeg"); // Assign to the global variable

            if(largerImageData.length > 6){
              resolve(largerImageData);
            } else {
              largerImageData = imageURL;
              reject(largerImageData);
            }

          };

          img.onerror = function() {
            //console.error("Error loading the image.");
            reject("Failed to fetch the larger image data.");
          };

          img.src = imageURL;
        });
      }

       if(this[main_photo_option] === null && main_photo_option == 'main_photo_after'){
         this['main_photo_after'] = this['main_photo_before'];
         this.main_photo_before_after_same = true;
       }

      const imageUrl = this[main_photo_option];

      largerImageData = getFourTimesLargerImageDataFromURL(imageUrl, this.zoomLevel)
         .then(largerImage => {
           if (largerImage) {
             // The largerImageData variable contains the Base64-encoded larger image data

             _this[main_photo_option + '_zoomed'] = largerImage;
             //console.log("Larger Image data:", largerImageData);

           } else {
             //console.log("Failed to fetch the larger image data.");
             alert("Failed to fetch the larger image data.")
           }
         })
         .catch(error => {
           //console.error(error);
           _this[main_photo_option + '_zoomed'] = error;
           //alert(JSON.stringify(error));
         });

      //console.log(main_photo_option + '_zoomed', _this[main_photo_option + '_zoomed']);
    },
    changeZoomStyle() {
      const imageContainer = document.querySelector('.' + 'main_photo_after_zoomed');
      let levelSwitchedOnZoom = false;
      let observedZoomedElementStyle = this.observedZoomedElementStyle;
      if (imageContainer) {
        const childElement = imageContainer.querySelector('.iiz__zoom-img');

        if (
            childElement.classList.contains('iiz__zoom-img') &&
            childElement.classList.contains('iiz__zoom-img--visible')
        ) {
          levelSwitchedOnZoom = true;
        }
      }

      this.$nextTick(() => {
        if(levelSwitchedOnZoom){
            for(const imageContainerClassTo of ['main_photo_after_zoomed', 'main_photo_before_zoomed']) {
              const imageContainerZoomed = document.querySelector('.' + imageContainerClassTo);
              if (imageContainerZoomed) {
                const imgElementZoomedTo = imageContainerZoomed.querySelector('.iiz__zoom-img');
                const imgElementTo = imageContainerZoomed.querySelector('.iiz__img');
                if (imgElementZoomedTo) {
                  if (!imgElementZoomedTo.classList.contains("iiz__zoom-img--visible")) {
                    imgElementZoomedTo.classList.add("iiz__zoom-img--visible");
                  }

                  let observedZoomedElementStyleObj = this.parseStyleToObject(this.observedZoomedElementStyle);
                  let zoomLevel = this.zoomLevel;
                  let zoomLevelOld = this.zoomLevelOld;
                  let scaleFactor = (zoomLevel / zoomLevelOld);
                  let maxTop = (-1) * (zoomLevel - 1) * 900;
                  observedZoomedElementStyleObj.top = parseInt(observedZoomedElementStyleObj.top, 10) * scaleFactor;
                  if (observedZoomedElementStyleObj.top < maxTop) observedZoomedElementStyleObj.top = maxTop;
                  observedZoomedElementStyleObj.top = observedZoomedElementStyleObj.top + 'px';
                  observedZoomedElementStyleObj.left = parseInt(observedZoomedElementStyleObj.left, 10) * scaleFactor + 'px';
                  this.observedZoomedElementStyle = this.combineObjectToStyle(observedZoomedElementStyleObj);

                  imgElementZoomedTo.style = this.observedZoomedElementStyle;
                }
                if (imgElementTo) {
                  if (!imgElementTo.classList.contains("iiz__img--hidden")) {
                    imgElementTo.classList.add("iiz__img--hidden");
                  }
                }
              }
            }
        }
        this.zoomLoading = false;
      });
    },
    parseStyleToObject(styleString) {
      let styleObject = {};
      let stylePairs = styleString.split(';');
      stylePairs.forEach(function(pair) {
        let parts = pair.trim().split(':');
        if (parts.length === 2) {
          styleObject[parts[0].trim()] = parts[1].trim();
        }
      });
      return styleObject;
    },
    combineObjectToStyle(styleObject) {
      let styleString = '';
      for (let key in styleObject) {
        if (styleObject.hasOwnProperty(key)) {
          styleString += key + ': ' + styleObject[key] + '; ';
        }
      }
      return styleString.trim();
    },
    afterZoomInMethod(imageContainerClassFrom, imageContainerClassTo){
      let _this = this;
      const imageContainerTo = document.querySelector('.' + imageContainerClassTo);
      const imageContainer = document.querySelector('.' + imageContainerClassFrom);

      if (imageContainer) {
        const childElement = imageContainer.querySelector('.iiz__zoom-img');

        if (
            childElement.classList.contains('iiz__zoom-img') &&
            childElement.classList.contains('iiz__zoom-img--visible')
        ) {
          _this.observedZoomedElementStyle = childElement.style.cssText;

          const imageContainerZoomed = document.querySelector('.' + imageContainerClassTo);
          if (imageContainerZoomed) {
            const imgElementZoomedTo = imageContainerZoomed.querySelector('.iiz__zoom-img');
            const imgElementTo = imageContainerZoomed.querySelector('.iiz__img');
            if (imgElementZoomedTo) {
              if (!imgElementZoomedTo.classList.contains("iiz__zoom-img--visible")) {
                imgElementZoomedTo.classList.add("iiz__zoom-img--visible");
              }
              imgElementZoomedTo.style = this.observedZoomedElementStyle;
            }
            if (imgElementTo) {
              if (!imgElementTo.classList.contains("iiz__img--hidden")) {
                imgElementTo.classList.add("iiz__img--hidden");
              }
            }
          }
        }

      }
    },
    afterZoomOutMethod(imageContainerClassFrom, imageContainerClassTo){

    },
    mainPhotoClick(imageContainerClassFrom, imageContainerClassTo) {
      let _this = this;
      setTimeout(() => {
        const imageContainerZoomedFrom = document.querySelector('.' + imageContainerClassFrom);
        if (imageContainerZoomedFrom) {
          const imgElementZoomedFrom = imageContainerZoomedFrom.querySelector('.iiz__zoom-img');
          const imgElementFrom = imageContainerZoomedFrom.querySelector('.iiz__img');

          if (imgElementZoomedFrom) {
            if (!imgElementZoomedFrom.classList.contains("iiz__zoom-img--visible")) {

              [imageContainerClassFrom, imageContainerClassTo].forEach((imageContainerClass) => {

                const imageContainerZoomed = document.querySelector('.' + imageContainerClass);
                const imgElementZoomed = imageContainerZoomed.querySelector('.iiz__zoom-img');
                const imgElement = imageContainerZoomed.querySelector('.iiz__img');

                if (imgElementZoomed) {
                  if (imgElementZoomed.classList.contains("iiz__zoom-img--visible")) {
                    imgElementZoomed.classList.remove("iiz__zoom-img--visible");
                  }
                  _this.observedZoomedElementStyle = _this.observedZoomedElementStyleOld;
                  imgElementZoomed.style = _this.observedZoomedElementStyleOld;
                }
                if (imgElement) {
                  if (imgElement.classList.contains("iiz__img--hidden")) {
                    imgElement.classList.remove("iiz__img--hidden");
                  }
                }
              });
            }
          }
        }
      }, 300);

    },
    zoomImageRatioErase(){
      for( const zoomLevel of this.zoomLevels){
        if('zoom_' + zoomLevel in window){
          if('imgHeight' in window['zoom_' + zoomLevel]){
            delete window['zoom_' + zoomLevel].imgHeight;
          }
          if('imgWidth' in window['zoom_' + zoomLevel]){
            delete  window['zoom_' + zoomLevel].imgWidth ;
          }
        }
      }

    },
    updateComputedValue() {
      this.$nextTick(() => {
        this.$forceUpdate(); // Force the component to re-render and update the computed property
      });
    },
    initSelectImage(){
      const defaultItemForSource = this.fullImageList.find(item => item.type === 'main_photo_after');
      if (defaultItemForSource) {
        this.selectedOptionSource = defaultItemForSource.value;
      }
      const defaultItemForHover = this.fullImageList.find(item => item.type === 'main_photo_before');
      if (defaultItemForHover) {
        this.selectedOptionHover = defaultItemForHover.value;
      }
    },
    initZoom(){
      this.setZoomImage('before');
      this.zoomImageRatioErase();
      this.readAndPreviewZoomImage('main_photo_before');
      this.readAndPreviewZoomImage('main_photo_after');
    },
    addBaseUrl(url){
      if (this.isURL(url))
        return url;

      if(url.length > 0 && url[0] != '/') url = '/' + url;
      let host = (process.env.VUE_APP_BASE_URL).replace(/\+$/, '');
      return host + url;
    },
    isURL(str) {
      if(!str)
        return false;

      return str.startsWith('http://') || str.startsWith('https://');
    }
  },
  async created() {
    this.initSelectImage();
    this.local_page_keys = await this.$filtergetLocalisationPage('order-photo-block');
    this.local_page_keys_functions = await this.$filtergetLocalisationPage('ru_retoucher_translations');
    this.zoomImageRatioErase();
  },
  computed: {
    appVersion(){
      let app = 1;
      if('app' in this.main_photo_block && this.main_photo_block.app){
        app =this.main_photo_block.app;
      }
      sessionStorage.setItem('appVersion', '' + app);
      return app;
    },
    order_photo_before_url_style(){

      let style = 'position: absolute;' +
          'background-color: #b62626;' +
          'aspect-ratio: '+this.aspectRatio+';' +
          'bottom: 0;' +
          'top: 50%;' +
          'left: 50%;' +
          'transform: translate(-50%, -50%);' +
          'width: max-content;height: 100%;' +
          'opacity: 0.5;' +
          'background-image: url('+this.addBaseUrl(this.main_photo_block.main_photo_before_with_faces)+');' +
          'background-position: 50%;' +
          'background-size: cover;';
      let dim = this.main_photo_block.resolution.order_photo_before_url.height > this.main_photo_block.resolution.order_photo_before_url.width ? 'height:100%; width: max-content;': 'width:100%; height: max-content;';

      if('order_photo_before_url' in this.main_photo_block.resolution
          && 'width' in this.main_photo_block.resolution.order_photo_before_url
          && 'height' in this.main_photo_block.resolution.order_photo_before_url
          && this.main_photo_block.resolution.order_photo_before_url.height / this.main_photo_block.resolution.order_photo_before_url.width > 2){

        return style +
            'background-size: 155%;' +
            'background-position-x: calc(50% - -20%);' +
            'background-position-y: calc(50% - 57%);';
      }

      return style + dim;
    },
    aspectRatio(){
      if('order_photo_before_url' in this.main_photo_block.resolution
          && 'width' in this.main_photo_block.resolution.order_photo_before_url
          && 'height' in this.main_photo_block.resolution.order_photo_before_url
      ){
        return ' ' + this.main_photo_block.resolution.order_photo_before_url.width + '/' + this.main_photo_block.resolution.order_photo_before_url.height;
      }
      return '';
    },
    isLoading() {
      return this.$store.state.loading.isLoading;
    },
    descriptionComputed() {
      if (this.main_photo_before_after_same)
        return 'before';

      if (this.afterVisible && !this.beforeVisible)
        this.setDescription('zone_photo', this.selectedOptionSource);

      if (this.afterVisible && this.beforeVisible)
        this.setDescription('zone_photo', this.selectedOptionHover);

      return this.description;
    },
    main_photo_before_zoomed_computed(){
      return this.main_photo_before_zoomed;
    },
    main_photo_after_zoomed_computed(){
      return this.main_photo_after_zoomed;
    },
    tooltipPhotoDownloadHover(){
      return this.parseFileName(this.selectedOptionHover)
    },

  },
  mounted() {
    this.orderId = this.main_photo_block.order_id;
    this.main_photo_before_with_faces = this.main_photo_block.main_photo_before_with_faces ? this.isURL(this.main_photo_block.main_photo_before_with_faces) ? this.main_photo_block.main_photo_before_with_faces : process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + this.main_photo_block.main_photo_before_with_faces : null;

    this.main_photo_before = Object.keys(this.main_photo_block).includes('main_photo_after')
        ? this.isURL(this.main_photo_block.main_photo_before) ? this.main_photo_block.main_photo_before : process.env.VUE_APP_API_BASE_URL.replace('api/v1', '') + this.main_photo_block.main_photo_before
        : this.main_photo_block.main_photo_before;

    this.main_photo_after = Object.keys(this.main_photo_block).includes('main_photo_after')
        ? this.main_photo_block.main_photo_after
        : null;

    if (!this.main_photo_before) {
      this.main_photo_before = this.main_photo_block.order_photo_before_url
          ? this.main_photo_block.order_photo_before_url
          : null;
    }
    if (!this.main_photo_after) {
      this.main_photo_after = this.main_photo_block.order_photo_after
          ? this.main_photo_block.order_photo_after
          : null;
    }
    this.fetchFunctionsClientFile();
    this.initZoom();
  },
  watch: {
    // Watch for changes in asyncData and trigger the computed property update
    main_photo_before_zoomed_computed: 'updateComputedValue',
    main_photo_after_zoomed_computed: 'updateComputedValue',
    zoomFactor: 'updateComputedValue',
    selectedOptionSource: function (newVal) {
      if (newVal) {
        this.main_photo_after = newVal;
        this.initZoom();
      }
    },
    selectedOptionHover: function (newVal) {
      if (newVal && this.selectedOptionSource) {
        this.main_photo_before = newVal;
        this.initZoom();
      }
    },
    zone_photo: function (newVal) {
      if ( this.zoneVisible && newVal) {
        this.beforeVisible = true
        this.photoAfterVisible = false
        this.main_photo_before = newVal;
        this.setDescription('zone_photo', newVal)
      } else {
        this.main_photo_before = this.selectedOptionHover;
      }
      this.initZoom();
    },
    isOutChat: function (newVal, oldVal) {
      if(newVal && !oldVal) {
        this.beforeVisible = false
        this.photoAfterVisible = true
       }
    }
  },
}
</script>
<style>
@import '../../../../assets/css/uikit/subnav.css';
@import '../../../../assets/css/vue-inner-image-zoom.css';

.selector[data-v-2bf22088] {
  border: 4px solid #fff;
}
[class*="_zoomed"].iiz {
  overflow: initial;
}
</style>